import { useEffect } from 'react'

export type WindowScrollCallback = (event: Event) => void

export const useWindowScroll = (cb: WindowScrollCallback) => {
  useEffect(() => {
    if (!window) {
      return undefined
    }

    window.addEventListener('scroll', cb, true)

    return () => {
      window.removeEventListener('scroll', cb, true)
    }
  }, [cb])

  return window
}

export default useWindowScroll
